module.exports = __webpack_public_path__ + "media/Greatgreat_granddaughter.2717b0ad.mp3";